<template>
	<div>
		<div v-if="this.$route.path == '/login'">
			<router-view />
		</div>
		<div v-else-if="this.$route.path == '/register'">
			<router-view />
		</div>
		<div v-else-if="this.$route.name == '404'">
			<NotFound />
		</div>
		<div v-else-if="this.$route.path == '/kayit-onaylandi'">
			<RegisterGo />
		</div>
		<div v-else-if="token">
			<div>
				<div class="d-flex flex-column flex-root" style="height: 100vh;">
					<div class="page d-flex flex-row flex-column-fluid">
						<asides />
						<div class="wrapper d-flex flex-column flex-row-fluid" id="kt_wrapper"
							style="padding-top: 70px !important;">
							<headers />
							<div class="content d-flex flex-column flex-column-fluid" id="kt_content">
								<div id="offline"><offline></offline></div>
          						<div id="online"><router-view></router-view></div>
							</div>
							<footers />
						</div>
					</div>
				</div>
				<stickyToolbars />
				<div id="kt_scrolltop" class="scrolltop" data-kt-scrolltop="true">
					<!--begin::Svg Icon | path: icons/duotune/arrows/arr066.svg-->
					<span class="svg-icon">
						<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
							<rect opacity="0.5" x="13" y="6" width="13" height="2" rx="1" transform="rotate(90 13 6)"
								fill="currentColor" />
							<path
								d="M12.5657 8.56569L16.75 12.75C17.1642 13.1642 17.8358 13.1642 18.25 12.75C18.6642 12.3358 18.6642 11.6642 18.25 11.25L12.7071 5.70711C12.3166 5.31658 11.6834 5.31658 11.2929 5.70711L5.75 11.25C5.33579 11.6642 5.33579 12.3358 5.75 12.75C6.16421 13.1642 6.83579 13.1642 7.25 12.75L11.4343 8.56569C11.7467 8.25327 12.2533 8.25327 12.5657 8.56569Z"
								fill="currentColor" />
						</svg>
					</span>
					<!--end::Svg Icon-->
				</div>
			</div>
		</div>
		<div v-else>
			<Login />
		</div>
	</div>
</template>

<script>
//DENEME
import HomePage from '@/views/HomePage.vue'
import Login from '@/views/Login.vue'
import NotFound from '@/views/404.vue'
import Offline from "@/views/Offline.vue";
import RegisterGo from "@/views/Regisgo.vue";

import asides from "@/components/asides.vue";
import contents from "@/components/contents.vue";
import footers from "@/components/footers.vue";
import headers from "@/components/headers.vue";
import stickyToolbars from "@/components/stickyToolbars.vue";
import toolbars from "@/components/toolbars.vue";

export default {
	name: 'App',
	data() {
		return {
			token: '',
		}
	},
	components: {
		HomePage,
		Login,
		NotFound,
		Offline,
		RegisterGo,
		asides,
		contents,
		footers,
		headers,
		stickyToolbars,
		toolbars,
	},
	created() {
		this.token = this.$store.getters.getToken;
		this.offlineControl();
	},
	methods: {
		offlineControl() {
			setInterval(() => {
				const divOff = document.getElementById("offline");
				const divOn = document.getElementById("online");
				window.addEventListener("online", () => {
					divOff.style.display = "none";
					divOn.style.display = "block";
				});
				window.addEventListener("offline", () => {
					divOff.style.display = "block";
					divOn.style.display = "none";
				});
			});
		},
	}
}
</script>

<style>
#app {
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
}
#offline {
  display: none;
}
.card {
	border: 1px solid #eee;
}


</style>
